import React from "react";

import Link from "components/Link";
import Typography from "@mui/material/Typography";
import { ReactComponent as LongArrow } from "images/long_arrow.svg";

const CallToAction = ({ preTitle, title, body, link, linkText, flush }) => {
	return (
		<div className={[
			"callToAction",
			(flush ? 'margin-flush' : ''),
		].join(' ')}>
			<Link className="callToAction__link" href={link}>
				{preTitle && <Typography component="div" variant="h3" className="callToAction__pre-title">{preTitle}</Typography>}
				<Typography component="div" variant="h2" className="callToAction__title">{title}</Typography>
				{body && <Typography component="div" variant="large" className="callToAction__body">{body}</Typography>}
				<span className="callToAction__linkText">
					<span className="callToAction__linkText__label">{linkText}</span>
					<span className="callToAction__linkText__arrow" aria-hidden="true">
						<LongArrow />
					</span>
				</span>
			</Link>
		</div>
	);
};

export default CallToAction;